import { render, staticRenderFns } from "./EmiTable.vue?vue&type=template&id=2db3c08a&scoped=true"
import script from "./EmiTable.vue?vue&type=script&lang=js"
export * from "./EmiTable.vue?vue&type=script&lang=js"
import style0 from "./EmiTable.vue?vue&type=style&index=0&id=2db3c08a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db3c08a",
  null
  
)

export default component.exports